export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const permissions = JSON.parse(window.sessionStorage.getItem('rights'))
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermission = permissions.some(permission => {
        return permission === '*:*:*' || permissionFlag.includes(permission.menuId)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标识`)
    }
  },
  componentUpdated(el, binding, vnode) {
    const { value } = binding
    const permissions = JSON.parse(window.sessionStorage.getItem('rights'))

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value
      const hasPermission = permissions.some(permission => {
        return permissionFlag.includes(permission.menuId)
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标识`)
    }
  }
}
